import SearchCriteria, { LocationType } from "../../models/SearchCriteria";
import FilterCriteria from "../../pages/tripresult/TripSearchFilterModel";
import { SubFsmBuilder } from "little-fsm";
import { TripSearchFsmContext } from "./TripSearchFsmContext";
import { LocationDTO, OperatorDTO, TripDTO, TripResultDTO } from "../../apiclient/ApiDtos";

export type TripSearchFsmScheme = {
    context:TripSearchFsmContext,
    substates: [
        'selecting_location', 
        'search_progressing', 
        'search_cancelling',
        'showing_results',                 
        'showing_error', 
        'showing_filters',
        'showing_operator_details'
    ],
    events: {        
        'back': {},
        "location_requested": {locationType:LocationType}
        "location_selected": {locationType:LocationType, location:LocationDTO}

        "search_requested" : {searchCriteria:SearchCriteria},
        "search_succeeded" : {searchResults:TripResultDTO[]},
        "search_failed" : {errorMessage:string},
        "search_cancelled": {},
        "search_resumed": {},

        "operator_details_requested": {operator:OperatorDTO},

        "filters_requested": {},
        "filters_applied":{filterCriteria:FilterCriteria},

        "result_selected": {tripSearchResult:TripResultDTO}
    }
}

// just simple identity function
const $I = (x) => x;

export function tripSearchSubFsmBuilder() : SubFsmBuilder<TripSearchFsmScheme> {
    let subBuilder = new SubFsmBuilder<TripSearchFsmScheme>(); 

    subBuilder
        .entrySubstate("search_progressing")
        .entrySubstate("showing_results", {
            description:"results_exits", 
            satisfies:(c) => {
                return c.searchResults != null;
            }
        })

    subBuilder.substate("search_progressing")
        .transition('search_succeeded', 'showing_results', 
            (context, event) => context.withSearchResults(event.searchResults))
        .transition('search_failed', 'showing_error', 
            (context, event) => context.withSearchError(event.errorMessage))
        .termination('back', $I)
    
    subBuilder.substate('showing_results')
        .transition('search_requested', 'search_progressing', 
            (c, e) => c.withSearchCriteria(e.searchCriteria))        
        .transition('location_requested', 'selecting_location', 
            (c, e) => c.withSelectingLocationType(e.locationType))        
        .transition('filters_requested', 'showing_filters', $I)
        .transition('filters_applied', 'showing_results', (c, e) => c.withFilterCriteria(e.filterCriteria))
        .transition('operator_details_requested', 'showing_operator_details', 
            (c, e) => c.withSelectedOperator(e.operator))
        .completion('result_selected', 
            (c, e) => c.withSelectedTrip(e.tripSearchResult))
        .termination('back', $I);

    subBuilder.substate("selecting_location")
        .transition('back', 'showing_results', 
            (context, event) => context)
        .transition('location_selected', 'showing_results', (context, event) => {
            return context.withSelectedLocation(event.locationType, event.location);
        });

    subBuilder.substate("showing_error")
        .transition('search_requested', 'search_progressing', (c, e) => c.withSearchCriteria(e.searchCriteria)) 
        .termination('back', $I)
    
    subBuilder.substate("showing_filters")
        .transition('filters_applied', 'showing_results', $I)
        .transition('back', 'showing_results', $I)

    subBuilder.substate('showing_operator_details')
        .transition('back', 'showing_results', $I)

    return subBuilder;
}